/**
 * Directive pour un confirm au click
 * <a ng-confirm-click="Are you sure ?" confirmed-click="todo()" confirmed-yes="Oui" confirmed-no="Non" ng-confirm-class="small">...</a>
 * 
 * Options possibles :
 * - confirmed-description : ajout d'un text d'information
 * - confirmed-class : Ajout d'un class sur la modal
 * - confirmed-check-condition : permet d'ajouter une checkbox qui active le bouton de validation uniquement quand la checkbox est cochée
 * 
 */
app.directive('ngConfirmClick', ['$filter', function($filter){
    return {
        templateUrl: "/templates/partials/directives/ng-confirm-modal.html",
        transclude: true,
        link: function (scope, element, attr, ctrl, transclude) {
            var clickAction = attr.confirmedClick;
            scope.confirm_msg = attr.ngConfirmClick || $filter('translate')('veuillez_confirmer');
            scope.confirm_yes = attr.confirmedYes || $filter('translate')('oui');
            scope.confirm_no  = attr.confirmedNo || $filter('translate')('non');
            scope.css_class  = attr.ngConfirmClass || '';
            scope.confirm_description = attr.confirmedDescription || null;

            // Double sécurité : avec l'ajout d'une checkbox pour activer le bouton de validation
            let confirmedCheckCondition = attr.confirmedCheckCondition || null;
            scope.checkCondition = {
                enable: (confirmedCheckCondition) ? true : false,
                message:  confirmedCheckCondition,
                checked: false
            };

            var modalElt = $('.ng-confirm-modal', element).modal({
                closable  : false,
                allowMultiple: true,
                onApprove : function() {
                    scope.$eval(clickAction);
                }
            });

            element.bind('click',function (event) {
                modalElt.modal('show');
            });
        }
    };
}])